import React, { useCallback, useMemo, useState } from "react";
import classnames from "classnames";
import ReloadIcon from "@rsuite/icons/legacy/Reload";
import { IconButton } from "rsuite";
import { SensorDataRestoringRequest } from "@shared/models";
import { QUERY_EXECUTION_STATUS_ATHENA } from "@shared/constants";

import "./index.scss";

export interface SensorDataRestoringRequestStatusProps {
  item: SensorDataRestoringRequest;
  onReloadClick: (item: SensorDataRestoringRequest) => void;
}

const TIMEOUT = 2000; // 2 seconds

export default function SensorDataRestoringRequestStatus(props: SensorDataRestoringRequestStatusProps) {
  const { item, onReloadClick } = props;

  const [isLoading, setIsLoading] = useState(false);

  const status = useMemo(() => item.athena_query_execution_status, [item]);

  const canReloadInfo = useMemo(
    () => [QUERY_EXECUTION_STATUS_ATHENA.QUEUED, QUERY_EXECUTION_STATUS_ATHENA.RUNNING].find((s) => s === status),
    [status],
  );

  const handleReload = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, TIMEOUT);

    onReloadClick(item);
  }, [onReloadClick, item]);

  return (
    <div className={classnames("sensor-data-restoring-request-status", status)}>
      <div>{status}</div>
      {canReloadInfo ? (
        <div className="reload-block">
          <IconButton icon={<ReloadIcon />} circle size="xs" loading={isLoading} onClick={handleReload} />
        </div>
      ) : null}
    </div>
  );
}
